/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
//   import config from "../../config/activateUser.config.json";

import { NOTIFY_USER } from '../../api/graphql';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { toast } from 'react-hot-toast';

export interface notifyUserProps {
  applicationID: any;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface INotifyUserMethods extends IPluginMethodMap {
  notifyUser(args: notifyUserProps): Promise<any>;
}

export class NotifyUserService implements IAgentPlugin {
  readonly methods: INotifyUserMethods;

  constructor() {
    this.methods = {
      notifyUser: this.notifyUser.bind(this),
    };
  }

  async notifyUser(args: notifyUserProps) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(NOTIFY_USER, {
          applicationNo: args?.applicationID,
        });
        if (res?.data) {
          toast.success(res?.data?.notifyApplicant?.message);
        }
      }
    } catch (err: any) {
      toast.error(err?.message);
    }
  }
}
